import React from 'react';
import * as pt from 'prop-types';
import createReactClass from 'create-react-class';

import Loader from '../../../common/components/notifications/Loader';
import MetadataFilter from '../MetadataFilter';
import Assets from './Assets';

var AssetsListing = createReactClass({
    propTypes: {
        actions: pt.shape({
            delete: pt.func,
            edit: pt.func,
            get: pt.func
        }),
        data: pt.array.isRequired,
        onWorkspaceAction: pt.func
    },

    getInitialState: function () {
        return {
            filter: null,
            term: '',
            isTyping: false
        };
    },

    /*
        State Functions
     */
    termChanged: function (term) {
        this.setState({
            term: term,
            isTyping: false
        });
    },

    handleTypingStarted: function () {
        this.setState({
            isTyping: true
        });
    },

    toggleUpload: function () {
        this.props.onWorkspaceAction({
            type: 'upload'
        });
    },

    applyFilter: function (filter, event) {
        if (event) event.preventDefault();
        this.setState({
            filter: filter
        });
    },

    render: function () {
        if (this.props.isResolving) return <Loader message="Fetching" />;
        return this.renderListing();
    },

    renderListing: function () {
        var listing;

        if (this.state.isTyping) {
            listing = <Loader message='Filtering' />;
        } else {
            listing = <Assets
                {...this.props}
                mode={this.props.mode || 'manage'}
                assets={this.props.data}
                term={this.state.term.toLowerCase()}
                onOpenModal={this.toggleUpload}
                filter={this.state.filter}
            />;
        }

        var filterName = "Filter by Type";

        if (this.state.filter) {
            switch (this.state.filter) {
                case 'image': filterName = "Images"; break;
                case 'document': filterName = "Documents"; break;
                case 'video': filterName = "Videos"; break;
            }
        }

        return (
            <div className="asset-listing">

                <div className="callout clearfix">
                    <div className="col-md-7">
                        <MetadataFilter termChanged={this.termChanged} isTyping={this.handleTypingStarted}/>
                    </div>

                    <div className="col-md-3">
                        {this.renderFilter(filterName)}
                    </div>

                    <div className="col-md-2 text-right">
                        {this.props.mode != 'assign' && this.props.mode != 'assign-fallback' && this.props.mode != 'assign-slates' ?
                            <button className="btn btn-primary"
                                onClick={this.toggleUpload}
                            >
                                <i className="fa fa-upload"/> Upload Asset
                            </button> :
                            null
                        }
                    </div>
                </div>

                <div className="well clearfix">
                    {listing}
                </div>
            </div>
        );
    },

    renderFilter: function (filterName) {
        if (this.props.mode != 'assign-slates') {
            return (<div>
                <div className="btn-group">
                    <button type="button" className="btn btn-default" disabled={this.state.filter === null} onClick={this.applyFilter.bind(null, null)}>
                        <i className="fa fa-times"/>
                    </button>
                    <button type="button" className="btn btn-default dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                        {filterName} <span className="caret"/>
                    </button>
                    <ul className="dropdown-menu">
                        <li><a href="#" onClick={this.applyFilter.bind(null, 'image')}>Images</a></li>
                        <li><a href="#" onClick={this.applyFilter.bind(null, 'document')}>Documents</a></li>
                        <li><a href="#" onClick={this.applyFilter.bind(null, 'video')}>Videos</a></li>
                    </ul>
                </div>
            </div>);
        } else {
            return (<div>
                <div className="btn-group">
                    <button type="button" name="video" className={'btn btn-primary ' + (this.props.slatesMode == 'video' ? 'active' : '')} onClick={this.props.toggleSlateMode}>Videos</button>
                    <button type="button" name="image" className={'btn btn-primary ' + (this.props.slatesMode == 'image' ? 'active' : '')} onClick={this.props.toggleSlateMode}>Image</button>
                </div>
            </div>);
        }
    }
});

export default AssetsListing;
